import React, { Component } from 'react';
import { connect } from 'react-redux' ;
import { bindActionCreators } from 'redux';
import MediaPlayer from '../components/mediaPlayer';
import AudioPlayer from '../components/audioPlayer';
import { Media, Player, controls, utils } from 'react-media-player'
import CustomPlayPause from '../containers/react-media-player-play-pause';
import {prefix} from 'meld-clients-core/src/library/prefixes';

import Score from 'meld-clients-core/lib/containers/score';
import TEI from 'meld-clients-core/lib/containers/tei';
//import TEI from '../containers/tei'; 
import MyImage from 'meld-clients-core/lib/containers/image';

import { registerTraversal, traverse, setTraversalObjectives, checkTraversalObjectives } from 'meld-clients-core/lib/actions/index';
import { registerClock, tickTimedResource, PROCESS_ANNOTATION } from 'meld-clients-core/lib/actions/index'
import Mahler5NYPTimeline from '../containers/NYPTimeline';
//import { projectAnnotations } from '../actions/graph.js';
const { PlayPause, CurrentTime, Progress, SeekBar, Duration, MuteUnmute, Volume, Fullscreen } = controls
const { formatTime } = utils
const MEIManifestation = "https://meld.linkedmusic.org/terms/MEIManifestation";
const TEIManifestation = "https://meld.linkedmusic.org/terms/TEIManifestation";
const IIIFManifestation = "https://meld.linkedmusic.org/terms/IIIFManifestation";
const VideoManifestation = "https://meld.linkedmusic.org/terms/VideoManifestation";
const AudioManifestation = "https://meld.linkedmusic.org/terms/AudioManifestation";
const ImageManifestation = "https://meld.linkedmusic.org/terms/ImageManifestation";
const TimeSensitiveImageManifestation = "https://meld.linkedmusic.org/terms/TimeSensitiveImageManifestation";
const OpenAnnotation = "http://www.w3.org/ns/oa#Annotation";

const clockProvider = "https://nyphil.linkedmusic.org/resources/mp3/Listening-through-time-Phil-Smith.mp3";
const MAX_TRAVERSERS = 12;
const donotfollow = ["https://nyphil.linkedmusic.org/LD/People/","https://nyphil.linkedmusic.org/LD/Performances/",
										 "https://nyphil.linkedmusic.org/resources/"];

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			interview: {mp3: false, tei: false},
			width: false,
			definition: false,
			height: false,
			media: {performances: []},
			jumpedTime: false,
			lastMediaTick: 0
		};
	}
  updateDimensions() {
    this.setState({width: document.documentElement.clientWidth,
									 height: document.documentElement.clientHeight});
  }
	toggleScoreState(){
		if(this.state.showScore){
			this.setState({showScore: false});
		} else {
			this.setState({showScore: true});
		}
	}
	interestedInManifestationType(mType){
		switch(mType) {
			case "https://meld.linkedmusic.org/terms/TimeSensitiveImageManifestation":
			case "https://meld.linkedmusic.org/terms/ImageManifestation":
			case "https://meld.linkedmusic.org/terms/TEIManifestation":
			case "http://meld.linkedmusic.org/terms/TimeSensitiveImageManifestation":
			case "http://meld.linkedmusic.org/terms/ImageManifestation":
			case "http://meld.linkedmusic.org/terms/TEIManifestation":
				return true;
		}
		return false;
	}
	conductorForAnnotation(annotationBody){
		for(var i=0; i<annotationBody.length; i++){
			if(annotationBody[i]['@id'] in this.state.conductors){
				return annotationBody[i];
			}
		}
		return false;
	}
	setDefinition(definition){
		if(definition.role=='conductor'){
			this.setState({definition: definition, conductor: definition.classref});
		} else {
			this.setState({definition: definition});
		}
	}
	clearDefinition(){
		this.setState({definition: false, conductor: false});
	}
	setConductor(e){
		var classes = e.currentTarget.className.baseVal;
		if(classes.indexOf('conductor-')>-1){
			var start = classes.indexOf('conductor-')+10;
			var end = classes.indexOf(' ', start);
			this.setState({conductor: classes.substring(start, end)});
		}
	}
	unsetConductor(e){
		this.setState({conductor: false});
	}
	shortName(perf){
		if(perf['https://meld.linkedmusic.org/terms/hasShortName']){
			return perf['https://meld.linkedmusic.org/terms/hasShortName'];
		} else if(perf['http://purl.org/vocab/frbr/core#partOf'] && perf['http://purl.org/vocab/frbr/core#partOf']['https://meld.linkedmusic.org/terms/hasShortName']){
			return perf['http://purl.org/vocab/frbr/core#partOf']['https://meld.linkedmusic.org/terms/hasShortName'];
		}
	}
	selectPerformanceByShortName(perf){
		this.setState({performance: perf});
	}
	selectPerformance(perf){
		var parentPerformance = perf['http://purl.org/vocab/frbr/core#partOf'];
		if(parentPerformance && parentPerformance['https://meld.linkedmusic.org/terms/hasShortName']){
			this.setState({performance: parentPerformance['https://meld.linkedmusic.org/terms/hasShortName']});
		}
	}
	unselectPerformance(){
		this.setState({performance: false});
	}
	componentDidMount() {
		const graphUri = "https://nyphil.linkedmusic.org/LD/PhilSmith.json-ld";
		this.props.registerTraversal(graphUri,
																 {numHops: 4,
																	ignoreObjectPrefix: donotfollow,
																	extendObjectPrefix: ["https://meld.linkedmusic.org", "https://nyphil.linkedmusic.org"]
																 });
		window.addEventListener("resize", this.updateDimensions.bind(this));
	}
	interviewResources(){
		var interviewResources = {mp3:false, tei:false};
		var interview = this.props.graph.outcomes && this.props.graph.outcomes[1]
				? JSONLDCollection(this.props.graph.outcomes[1])	: [];
		for(var i=0; i<interview.length; i++){
			var embods = interview[i]["http://purl.org/vocab/frbr/core#embodiment"];
			for(var embi=0; embi<embods.length; embi++){
				if(isJsonLDType(embods[embi], TEIManifestation)){
					interviewResources.tei = embods[embi]['@id'];
				} else if (isJsonLDType(embods[embi], AudioManifestation)
									 || isJsonLDType(embods[embi], TimeSensitiveImageManifestation)){
					interviewResources.mp3 = embods[embi]['@id'];
				}
			}
		}
		return interviewResources;
	}
	performanceInfo(){
		var newMedia = Object.assign({}, this.state.media);
		var performances = this.props.graph.outcomes && this.props.graph.outcomes[3]
				? JSONLDCollection(this.props.graph.outcomes[3])
				: [];
		for(var p=0; p<performances.length; p++){
			var perf = performances[p];
			if(perf["http://purl.org/ontology/mo/performanceOf"] &&
				 perf["http://purl.org/ontology/mo/performanceOf"]['@id']== "https://nyphil.linkedmusic.org/LD/mahler-5-opening"){
				newMedia.performances.push(perf);
			}
		}
		return newMedia;
	}
	tick(id,t) {
		if(Math.floor(t.currentTime) > this.state.lastMediaTick || // if we've progressed across the next second boundary, 
			 t.currentTime < this.state.lastMediaTick) { // OR if we've gone back in time (user did a seek)...
			this.setState({ lastMediaTick: Math.floor(t.currentTime) }); // keep track of this time tick)
			// dispatch a "TICK" action 
			// any time-sensitive component subscribes to it, 
			// triggering time-anchored annotations triggered as appropriate
			this.props.tickTimedResource(id, Math.floor(t.currentTime));
		}
	}
	
	annotationsById(){
		return this.props.graph.outcomes && this.props.graph.outcomes[0]
			? JSONLDCollection(this.props.graph.outcomes[0]) : [];
	}
	findConductors(){
		var performances = this.props.graph.outcomes && this.props.graph.outcomes[3]
				? JSONLDCollection(this.props.graph.outcomes[3]) : [];
		var conductors = {};
		if(performances){
			for(var i=0; i<performances.length; i++){
				if(performances[i][prefix.mo+"conductor"]){
					var cond=performances[i][prefix.mo+"conductor"]['@id'];
					if(cond in conductors) {
						conductors[cond].performances.push(performances[i]);
					} else {
						conductors[cond] = {performances: [performances[i]]};
					}
					if(this.state.annotations.find(x=>
																				 (x[prefix.oa+"hasTarget"]['@id']
																					&& x[prefix.oa+"hasTarget"]['@id']==cond)
																				 || (Array.isArray(x[prefix.oa+"hasTarget"])
																						 && x[prefix.oa+"hasTarget"].find(z=>z['@id']=cond)))){
						conductors[cond].definition = this.state.annotations.find(
							x=>
								(x[prefix.oa+"hasTarget"]['@id']
								 && x[prefix.oa+"hasTarget"]['@id']==cond)
								|| (Array.isArray(x[prefix.oa+"hasTarget"])
										&& x[prefix.oa+"hasTarget"].find(z=>z['@id']=cond)));
						var condStatement;
						if(conductors[cond].definition[prefix.oa+"hasTarget"]['@id']
							 && conductors[cond].definition[prefix.oa+"hasTarget"]['@id']==cond){
							condStatement = conductors[cond].definition[prefix.oa+"hasTarget"];
						} else {
							condStatement = conductors[cond].definition[prefix.oa+"hasTarget"].find(z=>z['@id']=cond);
						}
						if(condStatement && condStatement[prefix.meld+"hasShortName"]) conductors[cond].shortName=condStatement[prefix.meld+"hasShortName"];
					}
				}
			}
		}
		return conductors;
	}
	gatherOutcomes(){
//		console.log("responding to change");
		this.setState({interview: this.interviewResources(), media: this.performanceInfo(), annotations: this.annotationsById(), conductors: this.findConductors()});
	}
	// checkTraversalObjectives(graph, objectives){
	// 	var newMedia =Object.assign({}, this.state.media);
	// 	var interview = {mp3: false, tei: false};
	// 	var changed = false;
	// 	for(var mani=0; mani<graph.length; mani++){
	// 		if('@type' in graph[mani]){
	// 			if(isJsonLDType(graph[mani], "https://meld.linkedmusic.org/companion/vocab/Interview")){
	// 				var embods = graph[mani]["http://purl.org/vocab/frbr/core#embodiment"];
	// 				for(var embi=0; embi<embods.length; embi++){
	// 					if(newMedia[embods[embi]['@id']]){
	// 						if(isJsonLDType(newMedia[embods[embi]['@id']], TEIManifestation)){
	// 							interview.tei = embods[embi]['@id'];
	// 						} else if (isJsonLDType(newMedia[embods[embi]['@id']], AudioManifestation)
	// 											 || isJsonLDType(newMedia[embods[embi]['@id']], TimeSensitiveImageManifestation)){
	// 							interview.mp3 = embods[embi]['@id'];
	// 						}
	// 					}
	// 				}
	// 			} else if(graph[mani]['@id'] && !(graph[mani]['@id'] in newMedia)){
	// 				for(var t=0; t<graph[mani]['@type'].length; t++){
	// 					if(this.interestedInManifestationType(graph[mani]['@type'][t])){
	// 						newMedia[graph[mani]['@id']] = graph[mani];
	// 						changed = true;
	// 						break;
	// 					}
	// 				}
	// 			} else if(isJsonLDType(graph[mani], OpenAnnotation)){
					
	// 			}
	// 		}
	// 	}
	// 	this.setState({media: newMedia, interview: interview});
	// }
	/*
	componentDidUpdate(prevProps, prevState) {
		if("graph" in prevProps) {
			// check our traversal objectives if the graph has updated
			if(prevProps.graph.graph.length !== this.props.graph.graph.length) {
				this.props.checkTraversalObjectives(this.props.graph.graph, this.props.graph.objectives);
//				this.checkTraversalObjectives(this.props.graph.graph, this.props.graph.objectives);
			}
			if(prevProps.graph.outcomesHash !== this.props.graph.outcomesHash) { 
				// outcomes have changed, need to update our projections!
				//				this.props.projectAnnotations(this.props.graph.outcomes);
				this.gatherOutcomes();
				//this.props.projectAnnotations(this.props.graph.outcomes[0]['@graph']);
				projectAnnotations(this.props.graph.outcomes[0]['@graph']);
			} else {
			}
		}
	}*/
  componentWillMount() {
    this.updateDimensions();
		this.props.setTraversalObjectives([
			{
				"@embed": "@always",
				"@type": "http://www.w3.org/ns/oa#Annotation"
			},
			{
				"@embed": "@always",
				"@type": "https://meld.linkedmusic.org/companion/vocab/Interview"
			},
			{
				"@embed": "@always",
				"@type": "https://meld.linkedmusic.org/companion/vocab/musicExample"
			},
			{
				"@embed": "@always",
				"@type": "http://purl.org/ontology/mo/Performance"
			}
		]);
		this.props.registerClock(clockProvider);
  }
	componentDidUpdate(prevProps, prevState){
		if(prevProps && "graph" in prevProps) {
			if(prevProps.traversalPool.running == 1 && this.props.traversalPool.running ==0){
				this.props.checkTraversalObjectives(this.props.graph.graph, this.props.graph.objectives);
				if(prevProps.graph.outcomesHash !== this.props.graph.outcomesHash ) {
//					console.log('rebuilding structures');
					//outcomes have changed, need to update our projections!
					this.gatherOutcomes();
				} else {
				}
				if(Object.keys(this.props.traversalPool.pool).length ){
					var uri = Object.keys(this.props.traversalPool.pool)[0];
					debugger;
					this.props.traverse(uri, this.props.traversalPool.pool[uri]);
				}
			} else if(Object.keys(this.props.traversalPool.pool).length && this.props.traversalPool.running < MAX_TRAVERSERS){
				var uri = Object.keys(this.props.traversalPool.pool)[0];
				this.props.traverse(uri, this.props.traversalPool.pool[uri]);
			} else if(this.props.traversalPool.running===0){
				if(prevProps.graph.outcomesHash !== this.props.graph.outcomesHash) {
					this.gatherOutcomes();
				} else {
				}
			} else {
				if(prevProps.graph.outcomesHash !== this.props.graph.outcomesHash) {
					this.gatherOutcomes();
				}
			}
		}
	}
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
	
	render() {
		var markedScore = <MyImage key={"/resources/img/Mahler-part.png"} uri={"/resources/img/Mahler-part-opening.png"}/>;
		var interviewView = markedScore;
		var width = this.state.width;
		var timelineHeight = Math.min(width * 222.5 / 1314.9455, 200);
		var mainHeight = this.state.height - 85 - timelineHeight;
		var audiouri = this.state.interview.mp3 || '';
		var tickfun = this.tick.bind(this);
		var currentPerformance = this.state.performance || false;
		var currentConductor = this.state.conductor || false
		if("mediaResources" in this.props.timesync &&
			clockProvider in this.props.timesync.mediaResources) { 
			const cT = this.props.timesync.mediaResources[clockProvider]["currentTime"];
			const syncs = this.props.timesync.mediaResources[clockProvider]["times"];
			const times = Object.keys(syncs).map((t) => Number(t)); // ensure number, not string
			if(times && cT){
				const timeToShow = Math.max(...times.filter( (t) => { return t <= cT }));
				const annotation = syncs[timeToShow];
				if(prefix.oa+'hasBody' in annotation){
					var linkedPerformance = annotation[prefix.oa+'hasBody'].filter(x=>(isJsonLDType(x, prefix.mo+'Performance')));
					if(linkedPerformance.length) {
						currentPerformance = linkedPerformance[0][prefix.meldterm+'hasShortName'];
					} else {
						var conductorObj = this.conductorForAnnotation(annotation[prefix.oa+'hasBody']);
						if(conductorObj){
							currentConductor = conductorObj[prefix.meldterm+"hasShortName"];
						}
					}
					
				}
			}
		}
		if(this.state.interview.mp3 && this.state.interview.tei){
			interviewView = ( <div id="podcast">
												  <div className="episode">Phil Smith (principal trumpet) talks Mahler 5</div>
  											    <TEI key={ this.state.interview.tei }
	  										         uri={ this.state.interview.tei }
												shortform={this.state.showScore}
												performances={this.state.media.performances}
												current={{performance:currentPerformance, conductor:currentConductor}}
												setPerformance={this.selectPerformance.bind(this)}
												clearPerformance={this.unselectPerformance.bind(this)}
		  									         currentDefinition={ this.setDefinition.bind(this) }
												         height={this.state.showScore ? mainHeight - 40 : mainHeight}
												         clearDefinition={this.clearDefinition.bind(this)}
																 showAnnotations={true}
												         annotations={this.state.annotations || []} />
												{this.state.showScore ? markedScore : false}
							<Media key={ audiouri }>
								<div className="media">
									<div className="media-player">
												<Player src={audiouri} onTimeUpdate={(t)=>tickfun(clockProvider, t)}/>
									</div>
									<div className="media-controls">
										<CustomPlayPause/>
										<SeekBar/>
										<div className="media-info">
											<CurrentTime/>
											<span>/</span>
											<Duration/>
										</div>
									</div>
								</div>
							</Media>
													{this.state.height>900 ? <div onClick={this.toggleScoreState.bind(this)} className={"scoreButton "+(this.state.showScore ? "active" : "passive")}/> : false}
												</div> );
		}
		var audio = this.state.media.performances && this.state.media.performances.map(
			(perf, ix)=>(<div className={"performance"+(currentPerformance && this.shortName(perf) == currentPerformance ? " current" : "")}
									 onMouseEnter={this.selectPerformance.bind(this, perf)} onMouseLeave={this.unselectPerformance.bind(this)}>
									 <div className="description">{perf['http://www.w3.org/2000/01/rdf-schema#label']}</div>
							<Media key={ perf["http://purl.org/vocab/frbr/core#embodiment"]['@id'] }>
								<div className="media">
									<div className="media-player">
										<Player src={perf["http://purl.org/vocab/frbr/core#embodiment"]['@id']}/>
									</div>
									<div className="media-controls">
										<CustomPlayPause/>
										<SeekBar/>
										<div className="media-info">
											<CurrentTime/>
											<span>/</span>
											<Duration/>
										</div>
									</div>
								</div>
									 </Media></div>));
		return (
				<div className="wrapper">
					<link rel="stylesheet" href="../style/style.css"/>
					<link rel="stylesheet" href="../style/CETEIcean.css"/>
					<div className="mainPane">
						<div className="audio">{audio}</div>
				    <div className="interview">
							{interviewView}
						</div>
						{this.state.definition &&
							<div id="defTargetPopup"><h3>{this.state.definition.head}</h3>
									<p>{this.state.definition.definition}</p>
							</div>}
			    </div>
  			  <Mahler5NYPTimeline width={this.state.width} height={timelineHeight} definition={this.state.definition} trumpeter={this.state.trumpeter} conductor={currentConductor} performance={currentPerformance} setConductor={this.setConductor.bind(this)} unsetConductor={this.unsetConductor.bind(this)}/>
				</div>
		);
	}
	
}
function projectAnnotations(annotations) {
		return (dispatch) => { 
//			console.log("~~~OUTSIDE MAP ", annotations);
			annotations.map( (outcome) => {
				// FIXME "targets" and "bodies" here should really be 
				// "fragments" and "payloads" or similar in the core reducer
				// TODO, think through and improve
//				console.log("~~~INSIDE MAP ", outcome);
				let outcomeWrapper = {
					targets: outcome["http://www.w3.org/ns/oa#hasTarget"],
					bodies: outcome
				}
				dispatch({
					type: PROCESS_ANNOTATION,
					payload: outcomeWrapper
				})
			})
		}
	}

function JSONLDCollection(obj){
	if(!obj)
		return [];
	if('@graph' in obj)
		return obj['@graph'];
	if('@id' in obj)
		return [obj];
	return [];
}

function isJsonLDType(obj, type){
	return '@type' in obj && ((Array.isArray(obj['@type']) && obj['@type'].indexOf(type)>-1)
														|| (!Array.isArray(obj['@type']) && obj['@type']==type));
}

function mapStateToProps({ graph , score , objectives , timesync, traversalPool }) {
	return { graph , score , objectives , timesync, traversalPool }
}

function mapDispatchToProps(dispatch) { 
	return bindActionCreators({
		registerTraversal, traverse,
		projectAnnotations, 
		setTraversalObjectives,
		checkTraversalObjectives,
		registerClock,
		tickTimedResource
 }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

